import { render, staticRenderFns } from "./sharePoster.vue?vue&type=template&id=62200bdf"
import script from "./sharePoster.vue?vue&type=script&lang=js"
export * from "./sharePoster.vue?vue&type=script&lang=js"
import style0 from "./sharePoster.vue?vue&type=style&index=0&id=62200bdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports